import { Component, OnInit,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

  imageoneHome: boolean = false;
  pageTitle:string;
  pageDisplay: string;

  constructor(private activatedroute: ActivatedRoute,private router: Router,private lazyLoadService: LazyLoadScriptService) { }

  ngOnInit(): void {
    var applicationName = "homeappelement";
    this.lazyLoadService.loadScript(environment["HOMEAPPURL"], applicationName).subscribe(_ => {
      let url = this.router.url;
      if (url == '/home') {
        this.pageTitle = "Home";
        this.pageDisplay = "home";
      } else if (url == '/dashboard') {
        this.pageTitle = "Dashboard";
        this.pageDisplay = "dashboard";
      } else if (url == '/managegoals') {
        this.pageTitle = "Manage Goals";
        this.pageDisplay = "manageGoals";
      } else if (url == '/viewgoals') {
        this.pageTitle = "View Goals";
        this.pageDisplay = "viewGoals";
      } else if (url == '/status-management') {
        this.pageTitle = "Status Management";
        this.pageDisplay = "statusManagement";
      } else if(url == '/tasks') {
        this.pageTitle = "Tasks Lists";
        this.pageDisplay = "taskList";
      } else if(url == '/task/new') {
        this.pageTitle = "New Task";
        this.pageDisplay = "newTask";
      } else if(url.includes('/task/edit')) {
        this.pageTitle = "Update Task";
        this.pageDisplay = "editTask";
      } else if(url == '/notes') {
        this.pageTitle = "Notes List";
        this.pageDisplay = "notes";
      } else if(url.includes('/note/add')) {
        this.pageTitle = "New Note";
        this.pageDisplay = "addNote";
      } else if(url.includes('/note/edit')) {
        this.pageTitle = "Update Note";
        this.pageDisplay = "editNote";
      } else if(url == '/eLogBook') {
        this.pageTitle = "E-Log Book";
        this.pageDisplay = "eLogBook";
      } else if(url == '/clienthome') {
        this.pageTitle = "Client Home";
        this.pageDisplay = "clienthome";
      } else if(url == '/newMessage') {
        this.pageTitle = "New Message";
        this.pageDisplay = "newMessage";
      } 

      console.info('Page Display:',this.pageDisplay);
      this.imageoneHome = true;
    });
  }

  ngOnDestroy(): void {
    this.imageoneHome = false;
  }

}